module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goVideoCategories()
      }
    }
  }, [_vm._v("戻る")])])]), _c('section', {
    staticClass: "content"
  }, [_c('dl', {
    staticClass: "container"
  }, [_c('dt', [_vm._v("㊙接客評価のポイント")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M20.mp4",
      "poster": _vm.poster('M20'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec846f3a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/video-service-question-point.pug
// module id = 1452
// module chunks = 1